import { ActionLink } from "@/components/ActionLink";
import { FeaturePanel } from "@/components/FeaturePanel";
import { MediaCard } from "@/components/MediaCard";
import { SectionHeading } from "@/components/SectionHeading";
import { academyCourseCards, academyHighlights, academySkills, routeCtas } from "@/data/siteContent";

export function AcademyPage() {
  return (
    <div>
      <section className="px-4 pb-20 pt-14 md:px-8 md:pt-20">
        <div className="mx-auto grid max-w-7xl items-center gap-10 md:grid-cols-[1fr_0.9fr]">
          <div className="space-y-8">
            <p className="eyebrow">Learning in public</p>
            <h1 className="font-display text-5xl leading-[1.03] text-text md:text-7xl">
              Teaching the work <span className="italic text-primary">clearly</span>
            </h1>
            <p className="max-w-2xl text-lg leading-8 text-muted">
              Tutorials, workshops, and learning paths for people who want depth without the fake guru voice or the
              content-farm version of expertise.
            </p>
            <div className="flex flex-wrap gap-4">
              {academySkills.map((skill) => (
                <span
                  key={skill}
                  className="rounded-pill border border-outline/20 bg-surface-high px-4 py-2 font-label text-xs uppercase tracking-[0.2em] text-muted"
                >
                  {skill}
                </span>
              ))}
            </div>
            <div className="flex flex-wrap gap-4">
              {routeCtas["/academy"].map((action, index) => (
                <ActionLink
                  key={action.label}
                  action={action}
                  variant={index === 0 ? "primary" : "secondary"}
                />
              ))}
            </div>
          </div>
          <div className="overflow-hidden rounded-[2rem] border border-outline/10 bg-surface-high">
            <img src="/assets/academy/image-01.webp" alt="" className="h-full w-full object-cover" />
          </div>
        </div>
      </section>

      <section className="bg-surface-low px-4 py-24 md:px-8">
        <div className="mx-auto max-w-7xl space-y-12">
          <SectionHeading
            eyebrow="Latest work"
            title="Technical teaching without performance"
            description="The point is to explain hard things plainly, show the tradeoffs, and leave people with something they can actually use."
          />
          <div className="grid gap-8 md:grid-cols-[1.2fr_0.8fr_0.8fr]">
            {academyHighlights.map((card, index) => (
              <MediaCard key={card.title} card={card} compact={index !== 0} />
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 py-24 md:px-8">
        <div className="mx-auto max-w-7xl space-y-12">
          <SectionHeading
            eyebrow="In development"
            title="Courses and workshops taking shape"
            description="Longer material is on the way, built around software design, technical communication, and the craft of explaining what you are building."
          />
          <div className="grid gap-8 md:grid-cols-3">
            {academyCourseCards.map((card) => (
              <FeaturePanel key={card.title} card={card} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

